import makeApi from '../client/api'

export const getDocumentsList = async (userId, token) => {
  const { api } = makeApi({ token })

  const { ok, data } = await api.get('/documents', { owner_id: userId })

  if (!ok) {
    throw data.message
  }

  return data
}

export const deleteDocumentById = async (id, token) => {
  const { api } = makeApi({ token })
  const { ok, data } = await api.delete(`/files/${id}`)

  if (!ok) {
    throw data.error
  }

  return data
}

// FIRST
export const buildUploadUlr = async (userId, mimeType, fileSizeInBytes, fileStream, token) => {
  const api = makeApi({ token })

  const data = {
    associated_to_model: 'user',
    associated_to_id: userId,
    external_filename: fileStream,
    field_name: 'identification_document',
    field_weight: fileSizeInBytes,
    mimeType: mimeType,
  }

  const response = await api.create('/files/build-upload-url', { data })

  if (!response) {
    throw response.error
  }

  return response
}

// SECOND
export const uploadFile = async (signedUrl, mimeType, fileSizeInBytes, fileStream) => {
  return fetch(signedUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': mimeType,
      'Content-length': fileSizeInBytes,
      'Access-Control-Allow-Origin': '*',
    },
    body: fileStream,
  })
}
